import React from "react";

export default function SchoolDashboard(){
  const stats=[
    {title:"Total Students",value:"1,245"},
    {title:"Total Teachers",value:"86"},
    {title:"Classes",value:"32"},
    {title:"Revenue",value:"$12,450"}
  ];

  const students=[
    {name:"Ananya Sharma",class:"10-A",status:"Active",fees:"Paid"},
    {name:"Rahul Kumar",class:"9-B",status:"Pending",fees:"Due"},
    {name:"Sneha Reddy",class:"8-C",status:"Inactive",fees:"—"},
    {name:"Arjun Patel",class:"7-A",status:"Active",fees:"Paid"}
  ];

  const statusColor=(s)=>{
    if(s==="Active") return "bg-green-500";
    if(s==="Pending") return "bg-yellow-500";
    return "bg-red-500";
  };

  return (
    <div className="flex min-h-screen bg-slate-100 font-sans">
      {/* Sidebar */}
      <aside className="w-64 bg-slate-900 text-white p-6 space-y-6">
        <h1 className="text-2xl font-semibold text-center">EduAdmin</h1>
        <nav className="space-y-2">
          {["Dashboard","Students","Teachers","Classes","Attendance","Exams","Fees","Settings"].map(item=> (
            <div key={item} className="px-4 py-3 rounded-xl hover:bg-slate-700 cursor-pointer transition">
              {item}
            </div>
          ))}
        </nav>
      </aside>

      {/* Main */}
      <main className="flex-1 p-8 space-y-8">
        {/* Topbar */}
        <div className="flex justify-between items-center">
          <input
            placeholder="Search..."
            className="px-4 py-2 rounded-xl border w-64 shadow-sm focus:outline-none"
          />
          <div className="bg-blue-600 text-white px-5 py-2 rounded-full text-sm shadow">
            Admin Panel
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map(card=> (
            <div key={card.title} className="bg-white p-6 rounded-2xl shadow">
              <p className="text-gray-400 text-sm">{card.title}</p>
              <h2 className="text-3xl font-semibold mt-2">{card.value}</h2>
            </div>
          ))}
        </div>

        {/* Table */}
        <div className="bg-white rounded-2xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Recent Students</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b text-gray-500 text-sm">
                  <th className="py-3">Name</th>
                  <th>Class</th>
                  <th>Status</th>
                  <th>Fees</th>
                </tr>
              </thead>
              <tbody>
                {students.map((s,i)=> (
                  <tr key={i} className="border-b last:border-none">
                    <td className="py-3">{s.name}</td>
                    <td>{s.class}</td>
                    <td>
                      <span className={`${statusColor(s.status)} text-white text-xs px-3 py-1 rounded-full`}>
                        {s.status}
                      </span>
                    </td>
                    <td>{s.fees}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}
